import { action, computed } from 'mobx';

import { AppManager, Variables } from 'core/index';

import { ContributionApp, ContributionModel } from 'apps/repository/app';
import { ContributionPageQuery } from 'apps/repository/gql';

export class ContributionPageAppManager extends AppManager {
  static registryName = 'ContributionPageAppManager';
  constructor(parent, init = {}) {
    super(parent, init);
    this.AppRef('contributionPage', ContributionApp);
    this.variables = new Variables({
      space: () => this.params.get('profile') || this.params.get('initiative'),
      slug: () => this.params.get('slug'),
      version: () => this.params.get('contributionId'),
      basepath: () => '',
    });
    this.variables.onChange(['space', 'slug', 'version'], this.NewPath);
  }

  @computed get loading() {
    return this.queries.get('contributionPage')?.loading;
  }

  @action NewPath = () => {
    const q = new ContributionPageQuery(this, {
      queryKey: 'contributionPage',
      onSysErr: this.onSysErr,
    });
    q.process(
      contributionPage => ContributionModel.Load(contributionPage),
      this.ContributionPageUpdate,
      { subPath: 'contribution' },
    );
    q.query();
  };

  @action ContributionPageUpdate = contributionModel => {
    this.contributionPage = contributionModel;
  };

  @action onSysErr = () => {
    // TODO
  };
}
